import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.54 22L12 13.46L3.46 22L2 20.54L10.54 12L2 3.46L3.46 2L12 10.54L20.54 2L22 3.46L13.46 12L22 20.54L20.54 22Z" fill={ fill || 'currentColor' } />
    </svg>
);
